import { DataVersion, LocationAlarmUpdatesDTO } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
dayjs.extend(utc);

export const LOCATION_ALARM_UPDATES_QUERY_KEY = 'location_alarm_updates';

export function useLocationAlarmUpdates(
  locationAlarmId: string,
  refetchInterval: number,
  timestamp: string,
  productType: 'scan' | 'remote-guarding' | 'enterprise' = 'remote-guarding',
  eventId?: string,
  refetchOnWindowFocus = true,
  dataVersion?: DataVersion
) {
  const date = dayjs.utc(timestamp);
  const partitionKey = date.format('YYYYMM');

  const hasValidParams =
    !!locationAlarmId &&
    locationAlarmId !== 'undefined' &&
    !!timestamp &&
    date.isValid() &&
    partitionKey !== 'Invalid';

  const searchParams = new URLSearchParams({
    product: productType,
    partitionKey,
  });
  if (eventId && productType === 'scan') {
    searchParams.append('eventId', eventId);
  }

  const url = `/v2/orm/location_alarms/status/${locationAlarmId}?${searchParams.toString()}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<LocationAlarmUpdatesDTO>(request, {
    queryKey: [LOCATION_ALARM_UPDATES_QUERY_KEY, locationAlarmId, dataVersion],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
    refetchOnWindowFocus,
    refetchOnMount: true,
    enabled: hasValidParams,
  });
}

export default useLocationAlarmUpdates;
